// Vietmap configuration
export const VIETMAP_CONFIG = {
  API_KEY: import.meta.env.VITE_VIETMAP_API_KEY || 'YOUR_VIETMAP_API_KEY',
  STYLE_URL: 'https://maps.vietmap.vn/maps/styles/tm/style.json',
  GEOCODING_URL: 'https://maps.vietmap.vn/api/geocode/v1/search',
  DEFAULT_CENTER: {
    LAT: 105.8342,
    LNG: 21.0278
  }, // Hanoi coordinates
  DEFAULT_ZOOM: 10,
  DEFAULT_COORDINATES: {
    LAT: 15.856637331835161,
    LNG: 108.12279533597632,
  }
};

// Google Maps configuration
export const GOOGLE_MAPS_CONFIG = {
  API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || 'YOUR_GOOGLE_MAPS_API_KEY',
  DEFAULT_CENTER: {
    LAT: 10.8231,
    LNG: 106.6297
  }, // Ho Chi Minh City coordinates
  DEFAULT_ZOOM: 10,
  DEFAULT_COORDINATES: {
    LAT: 15.856637331835161,
    LNG: 108.12279533597632,
  }
};

// Map provider type
export type MapProvider = 'vietmap' | 'google';
